import darken from "darken";

function createDarkToggleHandler(switchElement, circleElement) {
    const toggleClasses = ["forwards", "reverse"];

    return function () {
        switchElement.classList.add("is-switching");
        window.setTimeout(function () {
            switchElement.classList.remove("is-switching");
        }, 320);

        const [addClass, removeClass] = circleElement.classList.contains(
            toggleClasses[0]
        )
            ? toggleClasses.reverse()
            : toggleClasses;

        circleElement.classList.add(addClass);
        circleElement.classList.remove(removeClass);
    };
}


export default {
    init: function () {
        const switchElement = document.querySelector("#switch");
        const circleElement = document.querySelector("#circle");

        document
            .querySelector("#switch")
            .addEventListener(
                "click",
                createDarkToggleHandler(switchElement, circleElement)
            );

        const variables = JSON.parse(
            document.querySelector("main").dataset.darkenVariables
        );

        new darken({
            toggle: "#switch",
            remember: "darken-mode",
            class: "darken",
            variables,
            usePrefersColorScheme: false
        });
    }
};
